
const ValueStatement = () => {
  return (
    <section className="py-16" style={{ backgroundColor: '#F8F4EF' }}>
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center">
          <p 
            className="text-2xl lg:text-3xl font-medium leading-relaxed max-w-4xl mx-auto"
            style={{ color: '#2B2B2B', fontFamily: 'Manrope, Inter, sans-serif' }}
          >
            Automation that feels seamless, stable, and human. Not complex. Just systems that work.
          </p>
        </div>
      </div>
    </section>
  );
};

export default ValueStatement;
